// extracted by mini-css-extract-plugin
module.exports = {"dynamo-target":"dynamo-target_dynamo-target__DBYWj"};